import React from "react";
import { cn } from "../../lib/utils";

function PageHeading({ title, className }) {
  return (
    <div className={cn("", className)}>
      <h1 className="text-xl font-medium text-darkGray ">{title}</h1>
      <hr className="mt-2 border-darkGray/20 py-3" />
    </div>
  );
}

export { PageHeading };
